import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppState } from '../../app.service';
import { AccountService } from '../../../services/account.service';
import { ShopifyBuyService } from '../../../services/shopify.service';
import { ToastHelperService } from '../../../services/toast-helper.service';
import { Router } from '@angular/router';
import { ACCOUNT_URLS, ACTIVATION_URLS } from '../../app.routes.names';

export interface ChangePlanModalData {
  plan?: any;
  mdn?: string;
  isActive?: boolean;
}

@Component({
  selector: 'app-change-plan-modal',
  imports: [TranslateModule],
  templateUrl: './change-plan-modal.component.html',
  styleUrl: './change-plan-modal.component.scss'
})

export class ChangePlanModalComponent {
  private dialog = inject(MatDialogRef<any>);
  private appState = inject(AppState);
  private accountService = inject(AccountService);
  private shopifyService = inject(ShopifyBuyService);
  private toastHelper = inject(ToastHelperService);
  private router = inject(Router);
  private translate = inject(TranslateService);

  public data = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    document.body.classList.add('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('aria-hidden');
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('aria-hidden', 'true');
    }
  }

  beforeClose() {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
  }

  closeDialog(): void {
    this.beforeClose();
    this.dialog.close();
  }

  handleChangePlanCalls(): void {
    this.appState.loading = true;
    if (this.data?.isActive) {
      this.accountService.changePlan(this.data?.mdn, this.data?.plan?.metafields?.plan_id).then(() => {
        this.toastHelper.success(this.translate.instant('change-plan-modal.successfully-changed'));
        this.router.navigate([`${ACCOUNT_URLS.BASE}/${ACCOUNT_URLS.SUMMARY}`],{
          queryParams: { [ACTIVATION_URLS.PARAMS.MDN]: this.data?.mdn }
        });
      }, error => {
        this.toastHelper.error(error?.error?.errors?.[0]?.message || error.message);
      }).finally(() => {
        this.appState.loading = false;
        this.closeDialog();
      });
    } else {
      this.shopifyService.createCheckoutWithRefillPlan(this.data?.plan?.id, this.data?.mdn, 1, this.data?.plan?.sellingPlans[0]?.id, 'change_plan', this.data?.plan?.metafields?.plan_id).then((data) => {
        window.location.href = data.checkoutUrl;
      }, (error) => {
        this.toastHelper.error(error?.error?.errors?.[0]?.message || error.message);
      }).finally(() => {
        this.appState.loading = false;
        this.closeDialog();
      });

    }
  }

}
